export const headerBilling = [
  { key: "service", label: "Service" },
  { key: "date", label: "Date" },
  { key: "ammount", label: "Amount" },
  { key: "invoice", label: "Invoice (PDF)" },
];
